import Section from '../../../elements/Section'
import SlickSlider from '../../../elements/SlickSlider'
import Container from '../../../elements/Container'
import IconLeft from '/public/icons/icon-blog-left.svg'
import IconRight from '/public/icons/icon-blog-right.svg'
import styles from './styles.module.scss'
import Button from '../../../elements/Button'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import { CSSTransition } from 'react-transition-group'
import { getS3Url } from '../../../helpers/getS3Url'
import { useState } from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import moment from 'moment'

const formatDate = (date) => {
  if (!date || !date._d) return ''
  const d = moment(date._d).utc()
  return d.format('MMM D')
}

const Welcome = ({ buttonLabel, featuredBlogs }) => {
  const [active, setActive] = useState(0)
  const { isTablet, isLargeDesktop } = useResponsive()
  const router = useRouter()

  let width = isTablet ? 24 : isLargeDesktop ? 40 : 60
  let height = isTablet ? 18 : isLargeDesktop ? 30 : 43

  return (
    <Section variant={['full-height', 'p-xs', 'bottom', 'o-hidden']}>
      <Head>
        {featuredBlogs &&
          featuredBlogs[router.locale].map((item, index) => (
            <link
              key={`prefetch-${index}`}
              rel="prefetch"
              href={getS3Url(
                item.cloudflare_hero_image || item.hero_image,
                '1980'
              )}
              as="image"
              type="image/jpeg"
            />
          ))}
      </Head>
      <Container>
        {featuredBlogs &&
          featuredBlogs[router.locale].map(
            (item, index) =>
              active === index && (
                <CSSTransition
                  classNames="opacity"
                  appear={true}
                  in={active === index}
                  timeout={{ enter: 200, exit: 200 }}
                  key={active}
                >
                  <div className={styles.image}>
                    <img
                      src={getS3Url(
                        item.cloudflare_hero_image || item.hero_image,
                        '1980'
                      )}
                      srcSet={`
                ${getS3Url(
                  item.cloudflare_hero_image || item.hero_image,
                  '360'
                )} 360w,
                ${getS3Url(
                  item.cloudflare_hero_image || item.hero_image,
                  '640'
                )} 640w,
                ${getS3Url(
                  item.cloudflare_hero_image || item.hero_image,
                  '960'
                )} 960w,
                ${getS3Url(
                  item.cloudflare_hero_image || item.hero_image,
                  '1980'
                )} 1980w,
                ${getS3Url(
                  item.cloudflare_hero_image || item.hero_image,
                  '3840'
                )} 3840w
              `}
                      sizes="100vw"
                      alt={`Blog Image ${item.title}`}
                      fetchpriority="high"
                    />
                  </div>
                </CSSTransition>
              )
          )}

        <div className={styles.overlay}></div>

        {featuredBlogs && (
          <SlickSlider
            className={styles.slider}
            prevArrow={<IconLeft width={width} height={height} />}
            nextArrow={<IconRight width={width} height={height} />}
            slidesToShow={1}
            afterChange={(index) => setActive(index)}
            variant={['white', 'arrow-auto']}
          >
            {featuredBlogs[router.locale].map((item, index) => (
              <Container key={`slide-${index}`} variant={['-xs5']}>
                <div className={styles.slide}>
                  <div className={styles.slide__date}>
                    {formatDate(item.published_date)}
                  </div>

                  <h2 className={styles.slide__title}>{item.title}</h2>

                  <p
                    dangerouslySetInnerHTML={{ __html: item.short_description }}
                  ></p>

                  {item.categories && (
                    <div className={styles.slide__tag}>
                      <em>{item.categories[0].title}</em>
                    </div>
                  )}

                  <Button href={`/stories/${item.slug}`} variant={['label']}>
                    {buttonLabel}
                  </Button>
                </div>
              </Container>
            ))}
          </SlickSlider>
        )}
      </Container>
    </Section>
  )
}

export default Welcome
